module.exports = __webpack_public_path__ + "img/q2.2_2022.035a5099.png";